import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { AccountService } from '../../Utils/_services/account/account.service';
import { ToastrService } from 'ngx-toastr';
import { IResetPassword_Request } from '../../Utils/_services/account/account.model';
import { AuthCtaComponent } from '../Layout/auth-cta/auth-cta.component';

@Component({
  selector: 'app-reset-password',
  standalone: true,
  imports: [
    CommonModule, 
    FormsModule, 
    RouterLink,
    AuthCtaComponent
  ],
  templateUrl: "./reset-password.component.html",
  styleUrl: "./reset-password.component.css"
})
export class ResetPasswordComponent implements OnInit {
  
  public resetPasswordModel: IResetPassword_Request = {
    newPassword: ""
  };
  public isLoading = false;
  public showPassword = false;
  public errorMessage = '';

  constructor(
    private accountService: AccountService,
    private router: Router,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    // this.accountService.currentUser$.pipe(take(1)).subscribe((currentUser: ILogin_Response | null) => {
    //   if (currentUser) {
    //     const redirectUrl = this.getRedirectUrlByRole(currentUser.role);
    //     this.router.navigate([redirectUrl]);
    //     return;
    //   }
    // });

    // const savedCredentials = localStorage.getItem('rememberedCredentials');
    // if (savedCredentials) {
    //   const credentials = JSON.parse(savedCredentials);
    //   this.loginModel.usernameOrEmail = credentials.usernameOrEmail;
    //   this.rememberMe = true;
    // }
  }

  onSubmit(): void {
    // if (this.isLoading) return;

    // if (!this.loginModel.usernameOrEmail || !this.loginModel.password) {
    //   this.errorMessage = 'Please enter both username/email and password.';
    //   return;
    // }

    // this.isLoading = true;
    // this.errorMessage = '';

    // this.accountService.loginUser(this.loginModel).subscribe({
    //   next: (response) => {
    //     this.isLoading = false;

    //     if (response.data && response.auth.token) {
    //       if (this.rememberMe) {
    //         localStorage.setItem('rememberedCredentials', JSON.stringify({
    //           usernameOrEmail: this.loginModel.usernameOrEmail
    //         }));
    //       } else {
    //         localStorage.removeItem('rememberedCredentials');
    //       }

    //       this.toastr.success(response.msg || 'Login successful!');

    //       const redirectUrl = this.getRedirectUrlByRole(response.data?.role || undefined);
    //       this.router.navigate([redirectUrl]);
    //     } else {
    //       this.errorMessage = response.msg || 'Login failed. Please try again.';
    //       this.toastr.error(this.errorMessage);
    //     }
    //   },
    //   error: (err: ICustomError) => {
    //     this.isLoading = false;
    //     this.errorMessage = err.error?.msg || 'Login failed. Please check your credentials and try again.';
    //     this.toastr.error(this.errorMessage);
    //     console.error('Login error:', err);
    //   }
    // });
  }

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  navigateToRegister(): void {
    this.router.navigate(['/auth/register']);
  }

  navigateToForgotPassword(): void {
    this.router.navigate(["/auth/login"]);
  }

  clearError(): void {
    this.errorMessage = '';
  }

  private getRedirectUrlByRole(role?: string): string {
    if (role && (role.toLowerCase() === 'admin' || role.toLowerCase() === 'administrator')) {
      return '/admin/dashboard';
    }
    return '/';
  }
}
